// Browse view state
import gql from 'graphql-tag';
import _ from 'lodash';
import { graphql } from '../../utils/fetch';
import Types from '../../foodItem-types';

const hasLocalStorage = (typeof Storage !== 'undefined');

function localStorageKey(key) {
  return `browse-${key}`;
}

function saveToLocalStorage(key, value) {
  if (hasLocalStorage) {
    localStorage[localStorageKey(key)] =
      (_.isObject(value) ? JSON.stringify(value) : value);
  }
}

function getFromLocalStorage(key, defValue, isObject) {
  if (hasLocalStorage) {
    const val = localStorage[localStorageKey(key)];
    if (_.isUndefined(val) || _.isNull(val)) {
      return defValue;
    } else if (isObject) {
      try {
        return JSON.parse(val);
      } catch (e) {
        return null;
      }
    }

    return val;
  }

  return defValue;
}

function toggleSortOrder(o) {
  if (o === 'asc') {
    return 'desc';
  }

  return 'asc';
}

const state = {
  // Food items to display
  foodItems: [],

  // Sort order
  sort: getFromLocalStorage('sort', {
    field: 'name',
    order: 'asc',
  }, true),

  // Selected categories
  // TODO - put in localstorage
  categories: null,

  // Selected types
  // TODO - put in localstorage
  types: Types.getTypeIds(),

  // Mode (table or tiles)
  mode: getFromLocalStorage('mode', 'table'),
};

const getters = {
  foodItems(s) {
    return s.foodItems;
  },
  sort(s) {
    return s.sort;
  },
  categories(s, g, rootState, rootGetters) {
    return (s.categories === null ? rootGetters.categoryNames : s.categories);
  },
  types(s) {
    return s.types;
  },
  mode(s) {
    return s.mode;
  },
};

const mutations = {
  foodItems(s, foodItems) {
    s.foodItems = foodItems;
  },
  categories(s, names) {
    s.categories = names.slice();
  },
  types(s, types) {
    s.types = types;
  },
  toggleSort(s, field) {
    s.sort = {
      field,
      order: (s.sort.field === field ?
        toggleSortOrder(s.sort.order) : 'asc'),
    };
    saveToLocalStorage('sort', s.sort);
  },
  mode(s, m) {
    saveToLocalStorage('mode', m);
    s.mode = m;
  },
};

const actions = {
  // eslint-disable-next-line no-shadow
  fetchFoodItems({ commit, state }) {
    return graphql.query({
      query: gql`query FoodItems($types: [TYPE!], $categories: [String!], $sort: SortType) {
        foodItems(types: $types, categories: $categories, sort: $sort) {
          id
          name
          access
          type
          description
          categories
          link
          ... on Restaurant {
            addrSortValue
            address {
              street
              city
              state
              country
            }
          }
        }
      }`,
      variables: {
        types: state.types,
        categories: state.categories,
        sort: state.sort,
      },
    })
    .then((response) => {
      commit('foodItems', response.data.foodItems);
      return response.data.foodItems;
    });
  },
};

export default {
  namespaced: true,

  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/browse.js